<template>
  <el-row class="gateway-container">
    <el-row v-if="loading || Ponds.length > 0">
      <el-row class="post-header" style="padding: 10px 10px;">
        <er-button
          size="mini"
          btnType="save"
          :showLabel="true"
          :showIcon="true"
          :loading="buttonloading"
          :disabled="isReadOnly"
          @click="handleSaveDetails"
        ></er-button>
        <div
          style="
    margin-left: 17px;
"
        >
          <er-button
            size="mini"
            btnType="cancel"
            :showLabel="true"
            :disabled="isReadOnly"
            @click="handleCancel"
          ></er-button>
        </div>
      </el-row>
      <el-row
        type="flex"
        justify="center"
        v-loading="loading"
        class="settings-gateway-table"
      >
        <el-col :span="7" :md="9" :lg="9" :xl="7">
          <er-data-tables
            uniqueId="gateway-settings__table"
            :tableData="tableData"
            :key="$i18n.locale"
            :columns="tableColumns"
            :actionColumn="false"
            size="mini"
            :pagination-props="$constants.table['pagination-props']"
            :default-sort="{ prop: 'code', order: 'ascending' }"
            type="white-header-table"
          >
            <template slot="empty">
              <span>
                <img class="no-data__img" src="@/assets/no_data.svg" />
              </span>
              <span class="no-data__text">
                <h3>{{ $t("Comn_no_data_connection") }}</h3>
              </span>
            </template>

            <template v-slot:alias_name="{ row }">
              <el-input
                size="mini"
                v-model="row.data.title"
                @change="handleGatewayChangeInTable($event, row.data)"
              ></el-input>
            </template>
          </er-data-tables>
        </el-col>
      </el-row>
    </el-row>
    <er-no-ponds :tabData="tabData" :disabled="isReadOnly" v-else />
  </el-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import errorHandlerMixin from "@/mixins/errorHandlerMixin";
import notificationMixin from "@/mixins/notificationMixin";

export default {
  mixins: [errorHandlerMixin, notificationMixin],
  props: {
    tabData: {
      default: {}
    }
  },
  data: function() {
    return {
      tableData: [],
      isTableEdited: false,
      loading: false,
      buttonloading: false
    };
  },
  computed: {
    ...mapGetters("gateway", {
      getGatewayData: "getGatewayData",
      getGatewayDataLoading: "getGatewayDataLoading"
    }),
    ...mapGetters("user", {
      getCurrUserLocation: "getCurrUserLocation",
      isReadOnly: "isReadOnly"
    }),
    ...mapGetters("pond", {
      Ponds: "getPonds"
    }),
    getObjGatewayData: function() {
      return this.getGatewayData.reduce((acc, x) => {
        acc[x._id] = x;
        return acc;
      }, {});
    },
    tableColumns() {
      return {
        gateway_id: {
          prop: "code",
          label: this.$t("Gateway_gateway_id"),
          // width: 200,
          sortable: "true",
          sortMethod: this.$commonUtils.naturalSort("code")
        },
        alias_name: {
          prop: "title",
          label: this.$t("Comn_alias_name")
          // width: 150
        }
      };
    }
  },
  async mounted() {
    this.loading = true;

    await this.fetchAllPonds({
      location_id: this.getCurrUserLocation._id,
      get_all: true
    });
    await this.callStoreToFetchGatewayDetails();
    this.loading = false;
  },
  methods: {
    ...mapActions("gateway", {
      fetchGatewayData: "fetchGatewayData",
      saveGatewayDetails: "saveGatewayDetails"
    }),
    ...mapActions("pond", {
      fetchAllPonds: "fetchAllPonds"
    }),
    async callStoreToFetchGatewayDetails() {
      this.loading = true;
      try {
        await this.fetchGatewayData();
        this.tableData = this.$lodash.cloneDeep(this.getGatewayData).map(x => {
          x.title = x.title || x.code;
          return x;
        });
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    },
    handleCancel() {
      this.tableData = this.$lodash.cloneDeep(this.getGatewayData);
    },
    async handleSaveDetails() {
      this.buttonloading = true;
      const errors = [];

      try {
        this.isEditable(this.tabData);

        const payload = this.tableData.map((x, index) => {
          if (!x.title) {
            errors.push({
              message: `${this.$t("allias_name_must_be_filled")} ${this.$t(
                "Comn_in"
              )} ${this.$t("Comn_row")} ${index + 1}`
            });
          }
          x.title = x.title;
          return x;
        });

        if (!this.isTableEdited) {
          throw {
            type: "FAIL_TO_SAVE",
            errors: [
              {
                message: this.$t("Comn_no_changes_found", {
                  item: this.$t("Comn_gateway")
                })
              }
            ]
          };
        }

        if (errors.length > 0) {
          throw {
            type: "FAIL_TO_SAVE",
            errors: errors
          };
        }

        await this.saveGatewayDetails(payload);
        this.notificationSuccess("Gateway_gateway_alias_name_upd_success");
        await this.callStoreToFetchGatewayDetails();
      } catch (err) {
        this.errorMessages(err);
      } finally {
        this.buttonloading = false;
      }
    },
    handleGatewayChangeInTable(event, gw) {
      this.isTableEdited = true;
    }
  }
};
</script>

<style lang="scss">
.gateway-container {
  .post-header {
    padding-bottom: 10px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
  .settings-gateway-table {
    // padding-top: 12px;
    padding-bottom: 12px;
    &.el-table .el-input__inner {
      width: 130px;
    }
  }
}
</style>